export default __webpack_public_path__ + "static/media/leaves.f5e473630c7795eb87b665e860a7e882.jpg";